export const HEADER_HEIGHT = 52 // need it to be constant because it is used in other components as well

// Docked chat panel wrapper adds p-2 (8px) top padding + 1px border, so the
// panel header needs this height for its bottom border to align with the app header's.
export const CHAT_PANEL_DOCK_OFFSET = 9
export const CHAT_PANEL_HEADER_HEIGHT = HEADER_HEIGHT - CHAT_PANEL_DOCK_OFFSET

export const SIDEBAR_ICON_SIZE = 20

export const CONVERSATION_TITLE_MAX_LENGTH = 500

// One toast id for every "Failed to load conversations": the sidebar, the
// chat panel and the history page can all fail on the same request burst.
export const CONVERSATIONS_LOAD_ERROR_TOAST_ID = "conversations-load-error"

export const PDF_ANSWER_BOX_DEFAULT_FONT_SIZE = 12
export const PDF_CUSTOM_CHECKBOX_DEFAULT_SIZE = 14
